module.exports = __webpack_public_path__ + "img/text-desc.468f3cfe.svg";